import { Message } from 'element-ui';

/**
 * 
 * @param {object} file 文件信息
 * @param {number} size 限制的尺寸
 */
const fileSizeLimit = (file: any, size = 2) => {
  const isLt2M = file.size / 1024 / 1024 < size;
  if (!isLt2M) {
    Message.error(`上传图片大小不能超过 ${size}MB!`);
  }
  return isLt2M;
}

export default fileSizeLimit